import { useMutation } from "react-query";
import {
  ConfirmVehicleChangesParams,
  confirmVehicleChanges,
} from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const confirmVehicleChangesFn = async (params: ConfirmVehicleChangesParams) => {
  return await confirmVehicleChanges(params);
};

export function useConfirmVehicleChanges() {
  return useMutation(confirmVehicleChangesFn, {
    mutationKey: MUTATION_KEYS.confirmVehicleChanges,

    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
